import { render, staticRenderFns } from "./ApiCargo.vue?vue&type=template&id=175a3b77&"
import script from "./ApiCargo.vue?vue&type=script&lang=js&"
export * from "./ApiCargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports